import classnames from 'classnames/bind'
import { useRouter } from 'next/router'
import React, { ReactNode, useEffect, useState } from 'react'

import { useIsomorphicLayoutEffect } from '@unlikelystudio/react-hooks'

import Footer from '~/components/Footer'
import IntlMeta from '~/components/IntlMeta'
import Navigation from '~/components/Navigation'

import { useCssVariables } from '~/providers/CssVariablesProvider'
import { useNavigation } from '~/providers/NavigationProvider'

import use100vh from '~/hooks/use100vh'
import useFixScrollbarOverflow from '~/hooks/useFixScrollbarOverflow'

import { DefaultPageData } from '~/data/page-data/serializer'

import SliceManager from '../SliceManager'
import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface PageProps extends DefaultPageData {
  children?: ReactNode | ReactNode[]
}
/**
 * Page abstraction layout
 * @param props
 * @returns Component
 */
function Page({ children, slices, meta, global }: PageProps) {
  const router = useRouter()

  useFixScrollbarOverflow()
  use100vh()

  const { variables: cssVariables } = useCssVariables()

  useIsomorphicLayoutEffect(() => {
    const body = document.querySelector('body')
    const reduced = Object.keys(cssVariables).reduce(
      (prev, key) => prev + `--${key} : ${cssVariables[key]}; `,
      '',
    )
    body.setAttribute('style', reduced)
  }, [{ ...cssVariables }])

  const asPaddingTop = slices?.[0]?.type !== 'hero_main'

  return (
    <>
      <main className={cx(css.Page, { asPaddingTop })}>
        <IntlMeta meta={meta} />
        <Navigation
          {...global?.navigation}
          key="navigation"
          alternateLangs={meta?.alternateLanguages}
        />
        <div className={css.content}>{children}</div>
        <Footer {...global?.footer} alternateLangs={meta?.alternateLanguages} />
      </main>
    </>
  )
}

Page.defaultProps = {}

export default Page
